import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ImportContainer} from 'app/Model/dataProcess/importContainer';
import {ExportContainer} from 'app/Model/dataProcess/exportContainer';

export type InspectContext = '' | 'containerDetails' | 'containerCatalog' | 'exportContainerDetails';
export type ContainerType = 'import' | 'export';

@Component({
  selector: 'np-inspect-panel',
  templateUrl: './inspectPanel.component.html',
  styleUrls: ['./inspectPanel.component.css'],
  standalone: false
})
export class InspectPanelComponent implements OnInit {
  @Input() container: ImportContainer | ExportContainer | null;
  @Input() context?: InspectContext;
  @Input() catalogId: string | null = null;
  @Input() containerType: ContainerType = 'import';
  @Input() titleOverride?: string;
  @Input() logoLink?: string | null;

  @Output() closePanel = new EventEmitter<void>();
  @Output() containerSaved = new EventEmitter<ImportContainer | ExportContainer>();
  @Output() containerDeleted = new EventEmitter<void>();
  @Output() containerDuplicated = new EventEmitter<ImportContainer | ExportContainer>();

  get containerName(): string {
    return this.titleOverride || this.container?.name || 'n/b';
  }

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (!this.context) {
      const url = this.router.url;
      this.context = url.includes('container-details') ? 'containerDetails' : '';
    }
  }
}
